<template>
  <div>
    <swiper :options="swiperOption" class="planSwiper" ref="planSwiperRef">
      <swiper-slide class="planSwiperSlide" v-for="(plan) in plans" :key="plan.planNo">
        <v-card :class="cardStyle(plan.planNo)">
          <div class="ribbon" v-if="plan.premium.discPct && plan.premium.discPct > 0">
            <span class="ribbontitle">{{plan.premium.discPct}}% OFF!</span>
          </div>
          <v-layout fill-height column justify-center align-center>
            <div>
              <v-layout row justify-center align-center>
                <!-- <v-icon>{{appIcon[iconType]}}</v-icon> -->
                <span class="planTitle">{{plan.planDesc}}</span>
              </v-layout>
            </div>
            <div class="mt-3">
              <span class="planCurr">{{currPrefix}}</span>
              <span class="planPrice">{{formatDisplayNumber(plan.premium.premiumPayable)}}</span>
            </div>
            <div v-if="plan.premium.promotion">
              {{plan.premium.promotion}}
            </div>
            <div v-else>
              &nbsp;
            </div>
          </v-layout>
        </v-card>
      </swiper-slide>
    </swiper>
    <div class="mt-3">
      <v-btn block color="primary" @click.prevent="doSelectPlan(localSelected, true)" v-if="localSelected">
        Buy Now!
        <v-icon right>mdi-cart</v-icon>
      </v-btn>
    </div>
    <div class="elevation-1" v-if="activePlan">
      <table class="v-datatable v-table theme--light planTable">
        <tbody class="planBody">
          <tr v-for="limit in limitsText" :key="limit.value" :class="limit.main? 'titleRow' : ''">
            <td>
              <div class="planCol">
                <span v-html="formatHtml(limit.label)"></span>
              </div>
            </td>
            <td class="text-xs-center">
              <div class="planCol">
                <template v-if="activePlan.limits[limit.value]">
                  <template v-if="activePlan.limits[limit.value].strValue">
                    <span>{{activePlan.limits[limit.value].strValue}}</span>
                  </template>
                  <template v-else-if="activePlan.limits[limit.value].uomUN && activePlan.limits[limit.value].uomUN !== ''">
                    <span>{{getUomUN(activePlan.limits[limit.value].uomUN)}}</span>
                  </template>
                  <template v-else-if="activePlan.limits[limit.value].isSI">
                    <!-- For SI, show currPrefix and format Number -->
                    <span v-if="activePlan.limits[limit.value].uomAmt">{{currPrefix + formatDisplayNumber(activePlan.limits[limit.value].uomAmt, 0)}}</span>
                    <span v-else>{{currPrefix + '0'}}</span>
                  </template>
                  <template v-else>
                    <span v-if="activePlan.limits[limit.value].uomAmt">{{formatDisplayNumber(activePlan.limits[limit.value].uomAmt, 0)}}</span>
                    <span v-else>0</span>
                  </template>
                </template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { appIcon } from '@/const/underwriting'
import { formatDisplayNumber } from '@/utils/number'
import { uomUN } from '@/const/underwriting/package'

export default {
  data() {
    return {
      swiperOption: {
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        observeParents: true,
        slideToClickedSlide: true
      },
      localSelected: undefined
    }
  },
  computed: {
    appIcon() {
      return appIcon
    },
    activePlan() {
      if (this.localSelected && this.plans) {
        return this.plans.find(x => x.planNo === this.localSelected)
      }
      return null
    }
  },
  watch: {
    'selected': {
      handler: function (value) {
        this.localSelected = value

        if (this.activePlan && this.$refs.planSwiperRef && this.$refs.planSwiperRef.swiper) {
          const index = this.plans.indexOf(this.activePlan)
          this.$refs.planSwiperRef.swiper.slideTo(index, 1000, false)
        }
      },
      immediate: true
    }
  },
  methods: {
    formatHtml(text) {
      // Replace /r/n with html br
      return text.replace(new RegExp('\\r?\\n', 'g'), '<br />')
    },
    formatDisplayNumber(xNum, scale = 2) {
      return formatDisplayNumber(xNum, scale)
    },
    cardStyle(planNo) {
      if (planNo === this.localSelected) {
        return 'planCard cardActive'
      } else {
        return 'planCard'
      }
    },
    doSelectPlan(planNo, proceed = false) {
      const obj = {
        value: planNo,
        proceed: proceed
      }
      this.$emit('selectPlan', obj)
    },
    getUomUN(val) {
      if (val && uomUN[val]) {
        return uomUN[val]
      }
      return ''
    }
  },
  mounted() {
    if (this.$refs.planSwiperRef.swiper) {
      this.$refs.planSwiperRef.swiper.on('slideChange', () => {
        this.localSelected = this.plans[this.$refs.planSwiperRef.swiper.activeIndex].planNo
        // this.doSelectPlan(this.localSelected)
      })
    }
    // Swipe to selected index on mount
    if (this.activePlan) {
      if (this.$refs.planSwiperRef.swiper) {
        const index = this.plans.indexOf(this.activePlan)
        this.$refs.planSwiperRef.swiper.slideTo(index, 1000, false)
      }
    } else {
      // Default 1st plan if there was no plan defaulted
      this.localSelected = this.plans[0].planNo
      // this.doSelectPlan(this.localSelected)
    }
  },
  beforeDestroy() {
    if (this.$refs.planSwiperRef && this.$refs.planSwiperRef.swiper) {
      this.$refs.planSwiperRef.swiper.off('slideChange')
    }
  },
  props: {
    plans: {
      type: Array,
      default: () => []
    },
    limitsText: {
      type: Array,
      default: () => []
    },
    selected: {
      type: String,
      default: ''
    },
    currPrefix: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: ''
    }
  },
  components: {
    swiper,
    swiperSlide
  }
}
</script>

<style lang="scss">
@import "~swiper/dist/css/swiper.min.css";
@import "../../../../assets/scss/base.scss";
.planSwiper {
  .planSwiperSlide {
    width: 240px;
    padding: 10px;
    .planCard {
      height: 180px !important;
      &:hover {
        cursor: pointer;
        color: $primary;
        .icon {
          color: $primary;
        }
      }
      &.cardActive {
        background-color: $primary !important;
        color: white !important;
        .icon {
          color: white !important;
        }
      }
      .icon {
        font-size: 2.5em;
      }
      .planTitle {
        font-size: 1.8em;
      }
      .planCurr {
      }
      .planPrice {
        font-size: 2em;
      }
    }
  }
}
</style>
